import { render, staticRenderFns } from "./TheFilterMainWheelTruck.vue?vue&type=template&id=6af8db06&"
import script from "./TheFilterMainWheelTruck.vue?vue&type=script&lang=js&"
export * from "./TheFilterMainWheelTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports